import type * as React from 'react';

/**
 * Util to set focus on an element using it's reference attribute
 * Consumers using this util should always have trySetFocus as the custom function
 * @param ref Ref of the element or React component for which we should set focus
 * @param customFocus If true, we call the custom trySetFocus function call
 */
export function trySetFocusOnElement(
    /* eslint-disable-next-line @typescript-eslint/no-explicit-any --
     * See aka.ms/mini-lint-errors
     *	> Unexpected any. Specify a different type. */
    ref: React.RefObject<any> | HTMLElement,
    customFocus: boolean = false
): boolean {
    /* eslint-disable-next-line @typescript-eslint/no-explicit-any --
     * See aka.ms/mini-lint-errors
     *	> Unexpected any. Specify a different type. */
    function isFunction(focusFunction: any) {
        return typeof focusFunction === 'function';
    }

    if (ref) {
        // Call focus directly if the ref is a HTML element
        if (ref instanceof HTMLElement) {
            isFunction(ref.focus) && ref.focus();
            return true;
        } else if (ref.current) {
            if (customFocus) {
                isFunction(ref.current.trySetFocus) && ref.current.trySetFocus();
            } else {
                isFunction(ref.current.focus) && ref.current.focus();
            }
            return true;
        }
    }
    return false;
}
